import React from "react";
import "date-fns";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Conclusion from "./Conclusion";
import Archivos from "./Archivos";
import IconButton from "@material-ui/core/IconButton";
import DescriptionIcon from "@material-ui/icons/Description";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import SnackBar from "../../SnackBar";
const firebase = require("firebase");
require("firebase/firestore");

class Etapa2 extends React.Component {
  constructor() {
    super();
    this.state = {
      id: "",
      created: false,
      numExped: "",
      condusef: "",
      fechaAdmis: null,
      fechaAdmisP: [],
      coment1: "",
      fechaInfoViaElect: null,
      fechaIVEDatabase: null,
      fechaInfoViaElectP: [],
      idIVED: "idIVED",
      coment2: "",
      fechaAudConcil: null,
      fechaACDatabase: null,
      fechaAudConcilP: [],
      idACD: "idACD",
      coment3: "",
      fechaPrestInofAd: null,
      fechaPrestInofAdP: [],
      coment4: "",
      fechaAudienFinal: null,
      fechaAudienFinalP: [],
      coment5: "",
      descr: "",
      open: false,
      openPdf: false,
      archivoState: null,
      guardado: false,
      lista: ""
    };
    this.handleAdmision = this.handleAdmision.bind(this);
    this.handleInfoElectr = this.handleInfoElectr.bind(this);
    this.handleAudieConci = this.handleAudieConci.bind(this);
    this.handlePrestInofAd = this.handlePrestInofAd.bind(this);
    this.handleAudienFinal = this.handleAudienFinal.bind(this);
  }

  componentDidMount = async () => {
    // const notaSeleccionada = await this.props.notes[this.props.index];
    if (this.props.selectedNote.fase2) {
      const notaSeleccionada = await this.props.notes.filter(
        i => i.id === this.props.selectedNote.id
      )[0];

      await this.fullFields(notaSeleccionada.fase2);
    }
  };

  fullFields = data => {
    this.setState({
      id: data.id,
      numExped: data.numExped,
      condusef: data.condusef,
      fechaAdmis: data.fechaAdmis ? data.fechaAdmis.toDate() : null,
      fechaAdmisP: data.fechaAdmisP,
      coment1: data.coment1,
      fechaInfoViaElect: data.fechaInfoViaElect
        ? data.fechaInfoViaElect.toDate()
        : null,
      fechaInfoViaElectP: data.fechaInfoViaElectP,
      coment2: data.coment2,
      fechaAudConcil: data.fechaAudConcil ? data.fechaAudConcil.toDate() : null,
      fechaAudConcilP: data.fechaAudConcilP,
      coment3: data.coment3,
      fechaPrestInofAd: data.fechaPrestInofAd
        ? data.fechaPrestInofAd.toDate()
        : null,
      fechaPrestInofAdP: data.fechaPrestInofAdP,
      coment4: data.coment4,
      fechaAudienFinal: data.fechaAudienFinal
        ? data.fechaAudienFinal.toDate()
        : null,
      fechaAudienFinalP: data.fechaAudienFinalP,
      coment5: data.coment5
    });
  };

  handleAdmision(date) {
    this.setState({ fechaAdmis: date });
  }
  handleInfoElectr(date) {
    this.setState({ fechaInfoViaElect: date, fechaIVEDatabase: date });
  }
  handleAudieConci(date) {
    this.setState({ fechaAudConcil: date, fechaACDatabase: date });
  }
  handlePrestInofAd(date) {
    this.setState({ fechaPrestInofAd: date });
  }
  handleAudienFinal(date) {
    this.setState({ fechaAudienFinal: date });
  }

  render() {
    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid>
            <div style={{ width: "100%", display: "flex" }}>
              <TextField
                id="outlined-name"
                label="Numero del Expedirnte"
                style={{ marginRight: "10px" }}
                value={this.state.numExped}
                onChange={e => this.setState({ numExped: e.target.value })}
                margin="normal"
                variant="outlined"
              />
              <TextField
                id="outlined-name"
                label="Condusef"
                value={this.state.condusef}
                onChange={e => this.setState({ condusef: e.target.value })}
                margin="normal"
                variant="outlined"
              />
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Admision."
                value={this.state.fechaAdmis}
                onChange={this.handleAdmision}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaAdmisP"
                key="fechaAdmisP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaAdmisP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaAdmisP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment1}
                onChange={e =>
                  this.setState({
                    coment1: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*  <Button
                onClick={() => this.pdfAction("fechaAdmisP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button> */}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Informe via Electronico"
                value={this.state.fechaInfoViaElect}
                onChange={this.handleInfoElectr}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaInfoViaElectP"
                key="fechaInfoViaElectP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaInfoViaElectP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaInfoViaElectP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment2}
                onChange={e =>
                  this.setState({
                    coment2: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none"
                }}
              />
              {/*   <Button
                onClick={() => this.pdfAction("fechaInfoViaElectP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
           </Button> */}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Audiencia Conciliatoria"
                value={this.state.fechaAudConcil}
                onChange={this.handleAudieConci}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaAudConcilP"
                key="fechaAudConcilP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaAudConcilP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaAudConcilP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment3}
                onChange={e =>
                  this.setState({
                    coment3: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none"
                }}
              />
              {/* /    <Button
                onClick={() => this.pdfAction("fechaAudConcilP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button> */}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Informe Adicional"
                value={this.state.fechaPrestInofAd}
                onChange={this.handlePrestInofAd}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaPrestInofAdP"
                key="fechaPrestInofAdP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaPrestInofAdP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaPrestInofAdP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment4}
                onChange={e =>
                  this.setState({
                    coment4: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none"
                }}
              />
              {/* <Button
                onClick={() => this.pdfAction("fechaPrestInofAdP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>   */}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Audiencia Final"
                value={this.state.fechaAudienFinal}
                onChange={this.handleAudienFinal}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaAudienFinalP"
                key="fechaAudienFinalP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaAudienFinalP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaAudienFinalP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment5}
                onChange={e =>
                  this.setState({
                    coment5: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none"
                }}
              />
              {/*   <Button
                onClick={() => this.pdfAction("fechaAudienFinalP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
           </Button> */}
            </div>
          </Grid>
        </MuiPickersUtilsProvider>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          {window.respuesta.checkedC ? (
            <>
              <Button
                onClick={this.consluir}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Concluir
              </Button>
              <Button
                onClick={this.save}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Guardar
              </Button>
            </>
          ) : null}
        </div>
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.consluir}
            aria-labelledby="form-dialog-title"
          >
            <Conclusion
              consluir={this.consluir}
              descr={this.state.descr}
              guardarConclusion={this.guardarConclusion}
              text={"Motivo de Conclusion"}
              setDescr={this.setDescr}
            />
          </Dialog>
        </div>
        <Archivos
          lista={this.state.lista}
          abrir={this.state.openPdf}
          cerrar={this.cerrar}
          eliminar={this.eliminarAr}
        />
        {this.state.guardado && (
          <SnackBar
            open={this.state.guardado}
            handleClick={this.handleClick}
            handleClose={this.handleClose}
          />
        )}
      </div>
    );
  }
  cerrar = () => {
    this.setState({ openPdf: !this.state.openPdf });
  };

  eliminarAr = (archivo, url, nombre) => {
    const y = "fase2." + this.state.gui;
    const x = {
      [y]: firebase.firestore.FieldValue.arrayRemove({
        bucket: archivo,
        nombre: nombre,
        url: url
      })
    };

    const datosFiltrados = this.state.lista.filter(i => {
      return i.nombre !== nombre;
    });

    this.setState({ lista: datosFiltrados });
    this.setState({ [this.state.gui]: datosFiltrados });

    firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update(x);
  };

  pdfAction = gui => {
    this.setState({ gui: gui });
    switch (gui) {
      case "fechaAdmisP":
        this.setState({ lista: this.state.fechaAdmisP });
        break;
      case "fechaInfoViaElectP":
        this.setState({ lista: this.state.fechaInfoViaElectP });
        break;
      case "fechaAudConcilP":
        this.setState({ lista: this.state.fechaAudConcilP });
        break;
      case "fechaPrestInofAdP":
        this.setState({ lista: this.state.fechaPrestInofAdP });
        break;
      case "fechaAudienFinalP":
        this.setState({ lista: this.state.fechaAudienFinalP });
        break;
      default:
        console.log("algo salio mal");
    }
    this.setState({ openPdf: !this.state.openPdf });
  };
  consluir = () => {
    this.setState({ open: !this.state.open });
  };
  updateCondusef = async val => {
    await this.setState({ aseguradora: val });
    // this.update()
  };
  handleClose = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClick = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  guardarConclusion = async () => {
    await firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update({
        estado: 3,
        descr: this.state.descr,
        etapa: "2-Condusef",
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });
    this.setState({ open: !this.state.open });
    this.handleClick();
  };
  setDescr = e => {
    this.setState({ descr: e.target.value });
  };
  save = async () => {
    if (this.state.fechaIVEDatabase) {
      firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idIVED`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha Informe via Electronico`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaIVEDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaACDatabase) {
      firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idACD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha Audiencia Conciliatora`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaACDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    await firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update({
        fase2: {
          numExped: this.state.numExped,
          condusef: this.state.condusef,
          fechaAdmis: this.state.fechaAdmis,
          fechaAdmisP: this.state.fechaAdmisP,
          coment1: this.state.coment1,
          fechaInfoViaElect: this.state.fechaInfoViaElect,
          fechaInfoViaElectP: this.state.fechaInfoViaElectP,
          coment2: this.state.coment2,
          fechaAudConcil: this.state.fechaAudConcil,
          fechaAudConcilP: this.state.fechaAudConcilP,
          coment3: this.state.coment3,
          fechaPrestInofAd: this.state.fechaPrestInofAd,
          fechaPrestInofAdP: this.state.fechaPrestInofAdP,
          coment4: this.state.coment4,
          fechaAudienFinal: this.state.fechaAudienFinal,
          fechaAudienFinalP: this.state.fechaAudienFinalP,
          coment5: this.state.coment5
        },
        etapa: "2-Condusef",
        actualizado: this.props.selectedNote.name,
        descr: this.state.descr,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });
    await firebase
      .firestore()
      .collection("notificaciones")
      .add({
        text: `${this.props.selectedNote.name} ha actualizado el caso #${this.props.selectedNote.title}`,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(doc => console.log("notificacion", doc));
    this.handleClick();
  };

  onChangeHandler = async event => {
    console.log("do yu een come here brp?");
    const gui = event.target.id;
    console.log(event.target.files[0]);
    console.log(this.state.archivo);

    await this.setState({ archivo: event.target.files[0] });
    console.log(this.state.archivo);
    console.log(this.state.archivo.name);
    console.log(gui);

    const arch = this.state.archivo;
    const name = arch.name;
    let metadata = {
      contentType: "document/pdf"
    };

    const storageRef = firebase.storage().ref(this.props.selectedNote.id);
    let uploadTask = storageRef
      .child(gui + "/" + arch.name)
      .put(arch, metadata);

    let dele = this.props.selectedNote.id + "/" + gui + "/" + arch.name;

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function(snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
          default:
            console.log(" se fue por el default");
            break;
        }
      },
      function(error) {
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            console.log("User doesnt have permission to access the object");
            break;

          case "storage/canceled":
            // User canceled the upload
            console.log("User canceled the upload");
            break;

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            console.log("Unknown error occurred, inspect error.serverResponse");
            break;
          default:
            console.log(" se fue por el default");
            break;
        }
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          switch (gui) {
            case "fechaAdmisP":
              this.setState(prevState => ({
                fechaAdmisP: [
                  ...prevState.fechaAdmisP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaInfoViaElectP":
              this.setState(prevState => ({
                fechaInfoViaElectP: [
                  ...prevState.fechaInfoViaElectP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaAudConcilP":
              this.setState(prevState => ({
                fechaAudConcilP: [
                  ...prevState.fechaAudConcilP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaPrestInofAdP":
              this.setState(prevState => ({
                fechaPrestInofAdP: [
                  ...prevState.fechaPrestInofAdP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaAudienFinalP":
              this.setState(prevState => ({
                fechaAudienFinalP: [
                  ...prevState.fechaAudienFinalP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            default:
              console.log("algo salio mal");
          }
          this.save();
        });
      }
    );
  };
}
export default Etapa2;
